/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { FlashModule__factory } from "./FlashModule__factory";
